export default __webpack_public_path__ + "static/fr-f0950280567042a7f2586fc2c37bf02b.png";